"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    palette: palette,
    display: 'block',
    circleColor: palette.elAccent,
    color: palette.tInactive,
    fontSize: palette.tsNormal,
    lineHeight: palette.tlNormal,
    padding: "".concat(palette.gutter, "px 0"),
    height: palette.gutter * 4 + 'px',
    width: palette.gutter * 4 + 'px',
    top: 'auto',
    left: 'auto',
    transform: 'none',
    position: 'relative',
    textAlign: 'center',
    margin: 0
  };
}